import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.SUPER_ADMIN};

const path = "admin/manual-guide";

export const List = async (values) => {
  return await axiosInstance(options).post(`${path}/list`, values);
};

export const Add = async (values) => {
  return await axiosInstance(options).post(`${path}/add`, values);
};

export const Edit = async (values) => {
  return await axiosInstance(options).put(`${path}/edit`, values);
};

export const Delete = async (values) => {
  console.log(values)
  return await axiosInstance(options).delete(`${path}/delete?o_id=${values[0]}`);
};

export const Details = async (id) => {
  return await axiosInstance(options).get(`${path}/details?o_id=${id}`);
};

export const Status = async (values) => {
  return await axiosInstance(options).patch(`${path}/change-status`, values);
};

export const updateprofile = async (values) => {
  return await axiosInstance(options).post(`${path}/edit-profile`, values);
};


// from here module api's are listed

export const AddModule = async (values) => {
  return await axiosInstance(options).post(`${path}/module/add`, values);
};

export const EditModule = async (values) => {
  return await axiosInstance(options).put(`${path}/module/edit`, values);
};

export const moduleDetails = async (id) => {
  return await axiosInstance(options).get(`${path}/module/details?o_id=${id}`);
};


export const moduleList = async (values) => {
  return await axiosInstance(options).post(`${path}/module/list`, values);
};


export const deleteModule = async (id) => {
  return await axiosInstance(options).delete(`${path}/module/delete?_id=${id}`);
};

export const sortModuleList = async (values) => {
  return await axiosInstance(options).patch(`${path}/module/sort`, values);
};


//from here module image api's are listed 


export const AddImageModule = async (values) => {
  return await axiosInstance(options).post(`${path}/moduleImage/add`, values);
};

export const EditImageModule = async (values) => {
  return await axiosInstance(options).put(`${path}/moduleImage/edit`, values);
};

export const moduleImageDetails = async (id) => {
  return await axiosInstance(options).get(`${path}/moduleImage/details?o_id=${id}`);
};


export const moduleImageList = async (values) => {
  return await axiosInstance(options).post(`${path}/moduleImage/list`, values);
};


export const deleteImageModule = async (id) => {
  return await axiosInstance(options).delete(`${path}/moduleImage/delete?_id=${id}`);
};

export const sortModuleImageList = async (values) => {
  return await axiosInstance(options).patch(`${path}/moduleImage/sort`, values);
};





